module.exports = __webpack_public_path__ + "static/media/adobe-photoshop.8e40ff12.png";